import history from 'services/core/history';
import { LIQUIDITY_TYPE_ID } from 'constants/constants';
import { getfromDataObject } from 'utils/formatting';

export const isLiquidity = (item) => getfromDataObject(item, 'Type.Id') === LIQUIDITY_TYPE_ID;

export const redirectToReadOnlyPositionDetails = (baseUrl, positionId, tabId) =>
    history.push(`${baseUrl}/${positionId}/${tabId}/overview`);
